// [목적] 폴리오 생성 실패 errorCode(rag.*) → 사용자 노출용 한글 문구 매핑
// [이유] P1-02(2026-09-19 QA): '폴리오 생성에 실패했어요. (rag.OUTPUT_GUARDRAIL_FAILED)' 처럼 BE 내부
//        코드가 그대로 사용자에게 노출되고 있었다(ChatPage/ChatMobile pdf-failed 버블, NewFolioPage 실패
//        Alert). BE core/exception/codes.ts 의 defaultMessage 를 FE 가 import 할 수 없으므로(별도 배포
//        앱) 여기서는 생성 실패 경로에 실제로 등장하는 코드만 좁혀 동일한 한글 문구를 복제해 둔다.
// [사이드 이팩트] 없음(순수 조회 함수) — 매핑에 없는 코드/null 은 안전한 기본 문구로 대체.
// [수정 시 고려사항] BE core/exception/codes.ts 의 rag.* 엔트리를 추가/변경하면 이 맵도 함께 갱신할 것
//                   (생성 실패로 도달 가능한 코드: folio-pdf.processor.ts throw 지점 + generation.service.ts 참조).
const GENERATION_ERROR_MESSAGES: Record<string, string> = {
  'rag.OUTPUT_GUARDRAIL_FAILED': '생성 결과 검증에 실패했어요. 잠시 후 다시 시도해 주세요.',
  'rag.GENERATION_FAILED': '여행 일정 생성에 실패했어요. 잠시 후 다시 시도해 주세요.',
  'rag.PDF_RENDER_FAILED': 'PDF 변환 중 오류가 발생했어요. 잠시 후 다시 시도해 주세요.',
  'rag.FOLIO_PDF_JOB_FAILED': '폴리오 생성 작업이 실패했어요. 잠시 후 다시 시도해 주세요.',
  'rag.SESSION_NOT_FOUND': '대화 세션을 찾을 수 없어요. 새 대화를 시작해 주세요.',
  'rag.SESSION_EXPIRED': '대화 세션이 만료됐어요. 새 대화를 시작해 주세요.',
};

const DEFAULT_GENERATION_ERROR_MESSAGE =
  '알 수 없는 오류가 발생했어요. 잠시 후 다시 시도해 주세요.';

export function generationErrorMessage(errorCode?: string | null): string {
  if (!errorCode) return DEFAULT_GENERATION_ERROR_MESSAGE;
  return GENERATION_ERROR_MESSAGES[errorCode] ?? DEFAULT_GENERATION_ERROR_MESSAGE;
}
